import React from 'react';
import { Text } from '@fiverr-private/typography';
import { Tag, TagImage, TagPrefix } from '@fiverr-private/data_display';
import pathfinder from '@fiverr-private/pathfinder';

interface Props {
    name: string;
    imageSrc?: string;
    icon?: JSX.Element;
    platforSlug: string;
    onClick: () => void;
}

export const getSearchGigsUrl = (query: string): string =>
    pathfinder(
        'search_gigs',
        {
            id: 'vibe-coding',
            category_id: 'programming-tech',
        },
        { query: { source: 'vibe_coding', query } }
    );

export const LogoItem = ({ name, imageSrc, icon, platforSlug, onClick }: Props) => (
    <Tag
        variant="outline"
        clickableArea="multi"
        ariaLabel={name}
        size="md"
        target="_blank"
        href={getSearchGigsUrl(platforSlug)}
        onClick={onClick}
    >
        <TagPrefix>
            <TagImage
                src={imageSrc}
                alt={`${name} logo`}
                borderRadius="none"
                maxWidth="16px"
                maxHeight="16px"
                objectFit="contain"
                hidden={!imageSrc}
            />
            {icon}
        </TagPrefix>
        <Text as="span" fontWeight="semibold">
            {name}
        </Text>
    </Tag>
);
